export default __webpack_public_path__ + "static/products-image-2e21140508b53a2780f8d6dfa8665c5e.png";